import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { PageNotFoundComponent } from './modules/shared/utils/page-not-found/page-not-found.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { CreateReviewComponent } from "./components/review/create-review.component";
import { PublicProfileComponent } from "./modules/profile/person-info/public-profile.component";
import { PersonReviewsComponent } from "./components/review/person-reviews/person-reviews.component";
import { authGuard } from "./utils/authGuard";
import { CreateReviewResolver } from './resolvers/create-review.resolver';
import { CompetitionEventsComponent } from './components/home/competition-events/competition-events.component';
import { AboutPageComponent } from './components/about-page/about-page.component';
import { FaqComponent } from './components/faq/faq.component';
import { SubscribeComponent } from './components/subscribe/subscribe.component';
import { NewRideComponent } from './components/new-ride/new-ride.component';
import { CookieManagementComponent } from './components/cookie-management/cookie-management.component';

const routes: Routes = [
  { path: '', component: HomeComponent, title: 'Horse Hop' }, // Redirect is not used because it loses query params
  { path: 'home', component: HomeComponent, title: 'Horse Hop' },
  { path: 'login', component: LoginComponent, title: $localize`Log in | Horse Hop` },
  { path: 'register', component: RegisterComponent, title: $localize`Register | Horse Hop` },
  { path: 'cookie-consent', component: CookieManagementComponent, title: $localize`Cookie Management | Horse Hop` },
  { path: 'legal', loadChildren: () => import('./modules/legal/legal.module').then(m => m.LegalModule) },
  { 
    path: 'profile',
    loadChildren: () => import('./modules/profile/profile.module').then(m => m.ProfileModule)
  },
  { path: 'ride', loadChildren: () => import('./modules/ride/ride.module').then(m => m.RideModule) },
  { 
    path: 'messaging',
    loadChildren: () => import('./modules/messaging/messaging.module').then(m => m.MessagingModule),
    canActivate: [authGuard] 
  },
  { path: 'competitions', component: CompetitionEventsComponent, title: $localize`Competitions | Horse Hop` },
  { path: '404', component: PageNotFoundComponent, title: $localize`Page not found | Horse Hop` },
  { path: 'feedback', component: FeedbackComponent, title: $localize`Feedback | Horse Hop` },
  { 
    path: 'my-rides', 
    loadChildren: () => import('./modules/ride-management/ride-management.module').then(m => m.RideManagementModule),
    canActivate: [authGuard]
   },
  { path: 'booking', loadChildren: () => import('./modules/booking/booking.module').then(m => m.BookingModule) },
  { 
    path: 'review/:rbId/:pId',
    component: CreateReviewComponent,
    canActivate: [authGuard],
    title: 'Review ride | Horse Hop',
    resolve: { booking : CreateReviewResolver } 
  },
  { path: 'person/:id', component: PublicProfileComponent, title: $localize`Public profile | Horse Hop` },
  { path: 'person/:id/reviews', component: PersonReviewsComponent, title: $localize`Personal reviews | Horse Hop` },
  { path: 'payment', loadChildren: () => import('./modules/payment/payment.module').then(m => m.PaymentModule) },
  { path: 'about', component: AboutPageComponent, title: $localize`About | Horse Hop` },
  { path: 'faq', component: FaqComponent, title: $localize`FAQ | Horse Hop` },
  { path: 'ride-request', loadChildren: () => import('./modules/ride-request/ride-request.module').then(m => m.RideRequestModule) },
  { path: 'ride-offer', loadChildren: () => import('./modules/ride-offer/ride-offer.module').then(m => m.RideOfferModule) },
  { path: 'subscribe', component: SubscribeComponent, title: $localize`Subscribe | Horse Hop` },
  { path: 'new-ride', component: NewRideComponent, title: $localize`Create new ride | Horse Hop` },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
